import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Backdrop, CircularProgress, Container, Page } from "@common-ui/ui";
import { Header } from "../../components";
import {
  getAssetDetails,
  getOrgUsers,
  getUserProfileData,
} from "../../services";
import EditAssetForm from "./EditAssetForm";
import _ from "lodash";
import { useSelector } from "react-redux";

const EditAsset = () => {
  let history = useHistory();
  const { orgId, assetId } = useParams();
  const [breadcrumbs, setBreadcrumbs] = useState([
    { label: "All Assets", link: "/asset-list" },
  ]);

  const [asset, setAsset] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  let appRole = currentOrganization?.app_role;
  let isTechnician = appRole === "TECHNICIAN";

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function init() {
    try {
      let assetDetails = await getAssetDetails(orgId, assetId);
      setBreadcrumbs([
        ...breadcrumbs,
        { label: assetDetails?.name, link: null },
      ]);
      let orgUsers = await getOrgUsers(orgId);
      let { data: currentUser } = await getUserProfileData();

      if (isTechnician) {
        let filtered_array = _.filter(orgUsers, (user) => {
          return user.username === currentUser.username;
        });
        setUsers(filtered_array);
      } else {
        setUsers(orgUsers);
      }

      setAsset(assetDetails);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setAsset([]);
      alert(error);
    }
  }

  const Loader = () => {
    return (
      <Backdrop
        sx={{
          color: "var(--primary-main)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress size={60} data-testid="circular-progress" />
      </Backdrop>
    );
  };

  return (
    <Page title="Edit Asset">
      <Header
        xl
        name="Edit Asset"
        breadcrumbs={breadcrumbs}
        history={history}
      />
      <Loader showLoader={isLoading} />
      <Container maxWidth="md">
        <EditAssetForm
          asset={asset}
          orgId={orgId}
          setIsLoading={setIsLoading}
          assetId={assetId}
          users={users}
          appRole={appRole}
        />
      </Container>
    </Page>
  );
};

export default EditAsset;
